import { render, staticRenderFns } from "./NotOpen.vue?vue&type=template&id=012ea717&scoped=true"
import script from "./NotOpen.vue?vue&type=script&lang=js"
export * from "./NotOpen.vue?vue&type=script&lang=js"
import style0 from "./NotOpen.vue?vue&type=style&index=0&id=012ea717&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ea717",
  null
  
)

export default component.exports